module.exports = __webpack_public_path__ + "img/26.0c8f43eb.jpg";